module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-logo-5-294ff738493f1464bac517b518483bdc.png";